<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">تعریف شغل</h4>
    </div>
    <div class="card-body">
      <label class="form-label fw-bold">شرح کلی شغل</label>
      <textarea
          class="form-control"
          rows="3"
          placeholder="شغل را تعریف کنید"
          v-model="jobDescription.job_definition"
      ></textarea>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    jobDescription: {
      get() {
        return this.$store.state.jobDescription.jobDescription;
      }
    },
  },
}
</script>